import React, { useEffect, useRef, useState } from 'react'
import "./settings.css"
import errorToast from '../../components/toast/errorToast';
import { useDispatch } from 'react-redux';
import { companyEdit, companyView } from '../../redux/actions/settingsAction';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import successToast from '../../components/toast/successToast';
import Loading from '../../components/ui/loader/loader';
import { useAuth } from '../../context/AuthContext';

/**Settings Module */
export default function Settings() {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { isAdmin } = useAuth();
    const hasEffectRun = useRef(false);


    useEffect(() => {
        if (!hasEffectRun.current) {
            dispatch(companyView({}, onSuccess, onError));
            setLoading(true);
            hasEffectRun.current = true;
        }
    }, []);

    const onSuccess = (data) => {
        setData(data.data.data);
        setLoading(false);
    };

    const onEditSuccess = (data) => {
        setData(data.data.data);
        setLoading(false);
        successToast(data.data.message)
    };

    const onError = (data) => {
        errorToast(data.data.message);
    };

    const initialValues = {
        company_name: data?.company_name || '',
        owner_name: data?.owner_name || '',
        email: data?.email || '',
        address: data?.address || '',
        mobile: data?.mobile || '',
    }

    const validationSchema = Yup.object().shape({
        company_name: Yup.string().required("Required"),
        owner_name: Yup.string().required("Required"),
        email: Yup.string().required("Required"),
        address: Yup.string().required("Required"),
        mobile: Yup.string().required("Required")
    });

    const onSubmit = (values) => {
        console.log(values, "form values");
        dispatch(companyEdit(values, onEditSuccess, onError))
    }

    useEffect(() => {
        document.title = 'Settings - Acumen Translation Hub';
    }, []);

    return (
        <div className='mt-1'>
            <div className='border-bottom py-2 position-sticky top-0 bg-white'>
                <h2 className='fs_20 fw_400 fn_Roboto mx-4 text-start'>Settings</h2>
            </div>
            <div className='w-100 mt-2'>
                {loading ? <Loading /> :
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ resetForm, dirty }) => (
                            <Form>
                                <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                    <label htmlFor="company_name" className="py-1 fw_600">Company Name</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            type="text"
                                            placeholder="Enter your company name"
                                            id="company_name"
                                            name="company_name"
                                            className="input-field"
                                            style={{ width: '25rem' }}
                                            disabled={!isAdmin}
                                        />
                                    </div>
                                    <ErrorMessage name="company_name" component="div" className="text-danger mt-1 fs_12" />
                                </div>

                                <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                    <label htmlFor="owner_name" className="py-1 fw_600">Owner Name</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            type="text"
                                            placeholder="Enter your name"
                                            id="owner_name"
                                            name="owner_name"
                                            className="input-field"
                                            style={{ width: '25rem' }}
                                            disabled={!isAdmin}
                                        />
                                    </div>
                                    <ErrorMessage name="owner_name" component="div" className="text-danger mt-1 fs_12" />
                                </div>

                                <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                    <label htmlFor="email" className="py-1 fw_600">Email</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            type="email"
                                            placeholder="Enter your email"
                                            id="email"
                                            name="email"
                                            className="input-field"
                                            style={{ width: '25rem' }}
                                            disabled={true}
                                        />
                                    </div>
                                    <ErrorMessage name="email" component="div" className="text-danger mt-1 fs_12" />
                                </div>

                                <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                    <label htmlFor="address" className="py-1 fw_600">Address</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            type="text"
                                            placeholder="Enter your name"
                                            id="address"
                                            name="address"
                                            className="input-field"
                                            style={{ width: '25rem' }}
                                            disabled={!isAdmin}
                                        />
                                    </div>
                                    <ErrorMessage name="address" component="div" className="text-danger mt-1 fs_12" />
                                </div>

                                <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                    <label htmlFor="mobile" className="py-1 fw_600">Mobile</label>
                                    <div className="d-flex position-relative">
                                        <Field
                                            type="text"
                                            placeholder="Enter your name"
                                            id="mobile"
                                            name="mobile"
                                            className="input-field"
                                            style={{ width: '25rem' }}
                                            disabled={true}
                                        />
                                    </div>
                                    <ErrorMessage name="mobile" component="div" className="text-danger mt-1 fs_12" />
                                </div>
                                {isAdmin &&
                                    <div className='mt-5 d-flex justify-content-between mx-4' style={{ width: '25rem' }}>
                                        <button type="button" className="btn btn-primary w-25 mx-4" onClick={() => resetForm()}>Reset</button>
                                        <button type="submit" className="btn btn-primary w-25 mx-4" disabled={!dirty}>Save</button>
                                    </div>
                                }
                            </Form>
                        )}
                    </Formik>
                }
            </div>
        </div>
    )
}